import { listBoxOption } from 'components/Form/SelectField/SelectField.helpers';
import { ListboxOption } from 'components/Form/SelectField/SelectField.types';
import { minMaxAgeValidator } from 'utils/validation/date';
import { requiredField } from 'utils/validation/required';
import { z } from 'zod';

export const promoCodeField = 'promoCode';
export const genderField = 'gender';
export const firstNameField = 'firstName';
export const lastNameField = 'lastName';
export const birthDateField = 'birthDate';
export const cityField = 'city';
export const streetAddressField = 'streetAddress';
export const professionField = 'jobId';

export const professionsOptions: ListboxOption[] = [
  {
    label: 'personalDataStep.select.profession.opt000',
    optionId: '000',
  },
  {
    label: 'personalDataStep.select.profession.opt001',
    optionId: '001',
  },
  {
    label: 'personalDataStep.select.profession.opt002',
    optionId: '002',
  },
  {
    label: 'personalDataStep.select.profession.opt003',
    optionId: '003',
  },
  {
    label: 'personalDataStep.select.profession.opt004',
    optionId: '004',
  },
  {
    label: 'personalDataStep.select.profession.opt005',
    optionId: '005',
  },
  {
    label: 'personalDataStep.select.profession.opt006',
    optionId: '006',
  },
  {
    label: 'personalDataStep.select.profession.opt007',
    optionId: '007',
  },
  {
    label: 'personalDataStep.select.profession.opt008',
    optionId: '008',
  },
  {
    label: 'personalDataStep.select.profession.opt009',
    optionId: '009',
  },
  {
    label: 'personalDataStep.select.profession.opt010',
    optionId: '010',
  },
  {
    label: 'personalDataStep.select.profession.opt011',
    optionId: '011',
  },
  {
    label: 'personalDataStep.select.profession.opt012',
    optionId: '012',
  },
  {
    label: 'personalDataStep.select.profession.opt013',
    optionId: '013',
  },
  {
    label: 'personalDataStep.select.profession.opt014',
    optionId: '014',
  },
  {
    label: 'personalDataStep.select.profession.opt015',
    optionId: '015',
  },
  {
    label: 'personalDataStep.select.profession.opt016',
    optionId: '016',
  },
  {
    label: 'personalDataStep.select.profession.opt017',
    optionId: '017',
  },
  {
    label: 'personalDataStep.select.profession.opt018',
    optionId: '018',
  },
  {
    label: 'personalDataStep.select.profession.opt019',
    optionId: '019',
  },
  {
    label: 'personalDataStep.select.profession.opt020',
    optionId: '020',
  },
  {
    label: 'personalDataStep.select.profession.opt021',
    optionId: '021',
  },
  {
    label: 'personalDataStep.select.profession.opt022',
    optionId: '022',
  },
  {
    label: 'personalDataStep.select.profession.opt024',
    optionId: '024',
  },
  // {
  //   label: 'personalDataStep.select.profession.opt024bis', //Removed Élève profession
  //   optionId: '024',
  // },
  {
    label: 'personalDataStep.select.profession.opt025',
    optionId: '025',
  },
  {
    label: 'personalDataStep.select.profession.opt026',
    optionId: '026',
  },
  {
    label: 'personalDataStep.select.profession.opt024bisbis',
    optionId: '024',
  },
];

export const genderFieldOptions: ListboxOption[] = [
  { label: 'personalDataStep.select.gender.000', optionId: '000' },
  { label: 'personalDataStep.select.gender.male', optionId: 'M' },
  { label: 'personalDataStep.select.gender.female', optionId: 'F' },
];

export const personalDataFormDefaultValues: PersonalDataFormType = {
  [promoCodeField]: '',
  [genderField]: genderFieldOptions[0],
  [firstNameField]: '',
  [lastNameField]: '',
  [birthDateField]: '',
  [cityField]: '',
  [streetAddressField]: '',
  [professionField]: professionsOptions[0],
};

export const personalDataStepFormValidationSchema = z.object({
  [promoCodeField]: z.string().optional(),
  [genderField]: listBoxOption.refine(
    (value) => value.optionId !== '000',
    'error.required',
  ),
  [firstNameField]: requiredField.pipe(
    z.string().min(2, 'error.minLength.2').max(50, 'error.maxLength.50'),
  ),
  [lastNameField]: requiredField.pipe(
    z.string().min(2, 'error.minLength.2').max(50, 'error.maxLength.50'),
  ),
  [birthDateField]: minMaxAgeValidator,
  [cityField]: requiredField.pipe(
    z.string().min(2, 'error.minLength.2').max(50, 'error.maxLength.50'),
  ),
  [streetAddressField]: requiredField.pipe(
    z.string().min(2, 'error.minLength.2').max(50, 'error.maxLength.50'),
  ),
  [professionField]: listBoxOption.refine(
    (value) => value.optionId !== '000',
    'error.required',
  ),
});

export type PersonalDataFormType = z.infer<
  typeof personalDataStepFormValidationSchema
>;
